import React from "react";
import { Tooltip, Typography, useTheme } from "@mui/material";
import {
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid/models";

interface Props {
  val: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>;
}

export default function RenderCell({ val }: Props) {
  const theme = useTheme();

  return (
    <Tooltip
      placement="top"
      title={
        <React.Fragment>
          <b>
            <em>
              {val.value === undefined || val.value === ""
                ? "--"
                : `${val.value ?? "--"}`}
            </em>
          </b>
        </React.Fragment>
      }
    >
      <Typography
        variant="body1"
        color={theme.palette.mode === "dark" ? "white" : "black"}
      >
        {val.value === undefined || val.value === ""
          ? "--"
          : `${val.value ?? "--"}`}
      </Typography>
    </Tooltip>
  );
}
